import React, { useState, useRef, useEffect } from "react";

const ProductsList = ({ products }) => {
  const [showAll, setShowAll] = useState(false);
  const containerRef = useRef(null);
  const prevHeight = useRef(null);

  const productsList = Array.isArray(products)
    ? products
    : typeof products === "string"
    ? products.split(/(?=[A-Z])/)
    : [];

  useEffect(() => {
    if (containerRef.current && prevHeight.current) {
      const scrollContainer =
        containerRef.current.closest(".table-container") || window;
      const heightDifference =
        containerRef.current.getBoundingClientRect().height -
        prevHeight.current;
      scrollContainer.scrollBy(0, heightDifference);
    }
    if (containerRef.current) {
      prevHeight.current = containerRef.current.getBoundingClientRect().height;
    }
  }, [showAll]);

  const Chip = ({ label, onClick, style }) => (
    <span
      onClick={onClick}
      style={{
        display: "inline-block",
        padding: "2px 8px",
        margin: "2px",
        backgroundColor: "#e0e0e0",
        borderRadius: "16px",
        fontSize: "12px",
        cursor: "pointer",
        ...style,
      }}
    >
      {label}
    </span>
  );

  const handleMoreClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setShowAll(true);
  };

  if (productsList.length === 0) {
    return <span>No products</span>;
  }

  return (
    <div ref={containerRef}>
      {(showAll ? productsList : productsList.slice(0, 2)).map(
        (product, index) => (
          <Chip key={index} label={product} />
        )
      )}
      {!showAll && productsList.length > 2 && (
        <Chip
          label={`+${productsList.length - 2} more`}
          onClick={handleMoreClick}
          style={{ backgroundColor: "#007bff", color: "white" }}
        />
      )}
    </div>
  );
};

export default ProductsList;
